import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeContextProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';
import { HomePage, RequireForms, RequireSession, EventAccess } from './components/InvitationAccess';
import EventForm from './components/EventForm';
import RSVPForm from './components/RSVPForm';
import EventAdmin from './components/EventAdmin';
import EventView from './components/EventView';
import RSVPEditForm from './components/RSVPEditForm';
import EventCalendar from './components/EventCalendar';

const App: React.FC = () => {
  return (
    <ThemeContextProvider>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Routes with persistent navbar */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/create" element={<RequireForms><EventForm /></RequireForms>} />
              <Route path="/admin/events/:slug" element={<RequireForms><EventAdmin /></RequireForms>} />
              <Route path="/view/events/:slug" element={<EventAccess><EventView /></EventAccess>} />
            </Route>

            {/* Standalone routes retain their event wallpaper after access is granted. */}
            <Route path="/events/:slug/calendar" element={<EventCalendar />} />
            <Route path="/rsvp/events/:slug" element={<EventAccess standalone><RSVPForm /></EventAccess>} />
            <Route path="/events/:slug/rsvp/edit/:editId" element={<RequireSession><RSVPEditForm /></RequireSession>} />
            <Route path="/events/:slug" element={<EventAccess standalone><RSVPForm /></EventAccess>} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeContextProvider>
  );
};

export default App;
